<template>
    <LoadingCard v-if="loading"></LoadingCard>
    <div v-else>
        <CreateWeedSprayDiary :user-id="userId" :blocks="availableBlocks" />
    </div>
</template>

<script>
import currentUserQuery from '@views/WeedSprayDiary/Create/queryCurrentUser.graphql';
import findBlockQuery from '@views/WeedSprayDiary/Create/queryFindBlock.graphql';
import listBlocksQuery from '@views/WeedSprayDiary/Create/queryListBlocks.graphql';

import CreateWeedSprayDiary from './Create';

export default {
  name: 'CreateWeedSprayDiaryContainer',
  props: ['blockId', 'cropTypeId'],
  components: {
    CreateWeedSprayDiary,
  },
  apollo: {
    currentUser: {
      query: currentUserQuery,
    },
    selectedBlock: {
      query: findBlockQuery,
      variables() {
        return {
          input: {
            id: this.blockId,
          },
        };
      },
      skip() {
        return !this.blockId;
      },
      update: data => data.findBlock,
    },
    userBlocks: {
      query: listBlocksQuery,
      variables() {
        return {
          input: {
            crop_type_id: this.cropTypeId,
            sort: {
              direction: 'DESC',
              field: 'name',
            },
          },
        };
      },
      skip() {
        return !!this.blockId;
      },
      update: data => data.filterBlocks.data,
    },
  },
  watch: {
    currentUser() {
      const validRole = ['grower', 'contractor'].includes(this.currentUser.role.name);

      if (!validRole || (this.currentUser.role.name === 'contractor' && !this.blockId)) {
        this.$notifyFailure('Not allowed.');
        setTimeout(() => this.$router.push({ name: 'dashboard' }), this.$redirectTimeout);
      }
    },
  },
  data() {
    return {
      currentUser: null,
      selectedBlock: null,
      userBlocks: [],
      loading: 0,
    };
  },
  computed: {
    availableBlocks() {
      return this.selectedBlock ? [this.selectedBlock] : this.userBlocks;
    },
    userId() {
      if (this.currentUser.role.name === 'contractor') {
        return this.$path.get(this.availableBlocks, '0.user_id');
      }
    },
  },
};
</script>
